import Breadcrumb from '@/components/breadcrumb';
import { BreadcrumbItemType } from '@/types/breadcrumb-item.type';

interface Props {
  title?: string;
  /** 제목 아래 한두 줄 소개 문구. 검색엔진이 읽는 화면 본문이라 숨기지 않는다 */
  description?: string;
  breadcrumbItems: BreadcrumbItemType[];
  /** 문자열 title로 표현하기 어려운 제목(강조 span 등)을 직접 넣을 때 */
  children?: React.ReactNode;
}

const PageHeader = ({
  title,
  description,
  breadcrumbItems,
  children,
}: Props) => {
  return (
    <div className="desktop:py-10 desktop:web-w desktop:mx-auto py-7">
      {/* 브레드크럼 */}
      <Breadcrumb items={breadcrumbItems} />
      {/* 페이지 타이틀 */}
      {title && (
        <div className="desktop:mt-10 desktop:mb-2 mx-auto mt-5 w-full">
          <h1 className="text-level-2 typo-28 desktop:typo-50 font-black">
            {title}
          </h1>
          {description && (
            <p className="text-level-4 typo-16 desktop:typo-18 desktop:mt-4 mt-3">
              {description}
            </p>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default PageHeader;
